export default __webpack_public_path__ + "static/media/archive-box.45721e02.svg";